import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './logo-carousel-item.component.scss';
var LogoCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(LogoCarouselItem, _super);
    function LogoCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    LogoCarouselItem.prototype.init = function () {
    };
    LogoCarouselItem.prototype.bindEvents = function () {
    };
    return LogoCarouselItem;
}(Base));
export { LogoCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/logo-carousel-item/logo-carousel-item.component.ts
// module id = 407
// module chunks = 0